import React, { Component } from 'react'
import FormGroup from 'live/components/forms/ui/form-group'

class Text extends Component {
    render() {
        const { label = '', value = '', help = '', required = true, name, onChange, validationState } = this.props

        return (
            <FormGroup
                type="text"
                label={
                    <span>
                        {' '}
                        {label} {required ? <abbr title="required">*</abbr> : null}
                    </span>
                }
                name={`config.${name}`}
                value={value}
                onChange={onChange}
                validationState={validationState(`config.${name}`)}
                hasFeedback
                help={help}
            />
        )
    }
}
export default Text
